<mat-toolbar color="primary">
  <div class="flex-container">

    <div class="flex-item align-center">
      <button (click)="newDialog()" mat-icon-button aria-label="Create new">
        <mat-icon fontIcon="fa-plus" fontSet="fas"></mat-icon>
      </button>

      <button (click)="openDialog()" mat-icon-button aria-label="Open">
        <mat-icon fontIcon="fa-folder-open" fontSet="fas"></mat-icon>
      </button>
      <button (click)="refreshData()" mat-icon-button aria-label="Refresh">
        <mat-icon fontIcon="fa-sync" fontSet="fas"></mat-icon>
      </button>
      @if (needsUpgrade) {
      <button mat-icon-button aria-label="Upgrade warning">
        <mat-icon color="warn" fontIcon="fa-exclamation-triangle" fontSet="fas"
          matTooltip="This view was automatically upgraded, and some features may be missing.  Please check the view and resave to complete the upgrade." />
      </button>
      }
    </div>
    <div class="flex-item align-center text-center document-title">

      @if (!isSaveable) {
      <span>{{ activeTemplateName }}</span>
      }
      @if (isSaveable) {
      <i>{{ activeTemplateName }} *</i>
      }
    </div>

    <div class="flex-item align-center text-right">

      @if (activeEntity === 'Visit' && visitTableViewer) {
        @if (visitTableViewer.bulkMode) {
          <button
            mat-flat-button
            color="accent"
            class="toolbar-bulk-action"
            [disabled]="visitTableViewer.selectedVisits.length === 0"
            (click)="visitTableViewer.openBulkTransformDialog()"
          >
            Bulk action ({{ visitTableViewer.selectedVisits.length }})
          </button>
        }
        <mat-slide-toggle
          class="toolbar-bulk-toggle"
          [ngModel]="visitTableViewer.bulkMode"
          (change)="visitTableViewer.toggleBulkMode($event.checked)"
          aria-label="Select rows"
        >
          Select Rows
        </mat-slide-toggle>
      }

      <button [matMenuTriggerFor]="toolbarUserMenu" mat-icon-button aria-label="More options">
        <mat-icon fontIcon="fa-ellipsis-vertical" fontSet="fas"></mat-icon>
      </button>


      <mat-menu #toolbarUserMenu="matMenu">

        <button (click)="savePreset()" [disabled]="!isSaveable" mat-menu-item>Save Changes
        </button>
        <button (click)="savePresetAs()" [disabled]="!isSaveAsable" mat-menu-item>Save As...
        </button>
        <button (click)="deleteDialog()" [disabled]="!isDeleteable" mat-menu-item>
          Delete View
        </button>
        <button (click)="exportToExcel()" [disabled]="!isExportable" mat-menu-item>
          Export to Excel
        </button>
      </mat-menu>

    </div>
  </div>
</mat-toolbar>
@if (activeEntity === 'Job') {
<app-job-table-viewer #jobTableViewer (gridChanged)="gridChanged()"></app-job-table-viewer>
}
@if (activeEntity === 'Meeting') {
<app-meeting-table-viewer #meetingTableViewer (gridChanged)="gridChanged()"></app-meeting-table-viewer>
}
@if (activeEntity === 'Visit') {
<app-visit-table-viewer #visitTableViewer (gridChanged)="gridChanged()"></app-visit-table-viewer>
}
@if (activeEntity === 'Ticket') {
<app-ticket-table-viewer #ticketTableViewer (gridChanged)="gridChanged()"></app-ticket-table-viewer>
}
@if (!activeEntity) {
<div class="views-container">
  @if (!loadedAvailablePresets) {
  <h3>Loading...</h3>
  }
  <mat-action-list>
    @for (preset of available; track preset) {
    <mat-list-item (click)="selectView(preset.id, preset.entityName)">

      <div>
        <mat-icon fontIcon="fa-file-spreadsheet" fontSet="fat" class="view-icon"></mat-icon>
        {{ preset.searchName }}
      </div>
    </mat-list-item>
    }
  </mat-action-list>
</div>
}